import { render, staticRenderFns } from "./MainLedgerListVAT.vue?vue&type=template&id=09ac53a0&scoped=true"
import script from "./MainLedgerListVAT.vue?vue&type=script&lang=js"
export * from "./MainLedgerListVAT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ac53a0",
  null
  
)

export default component.exports